import optionsApi from "./optionsApi";

export async function assignManagerManual(data: {
  managerId: string;
  employeeIds: string[];
}): Promise<any> {
  return optionsApi
    .post("/v1/manager-assignment/manual", data)
    .then((res) => res?.data);
}

export async function createManagerRule(data: {
  managerId: string;
  conditions: any;
  autoAssign: boolean;
}): Promise<any> {
  return optionsApi
    .post("/v1/manager-assignment/rule", data)
    .then((res) => res?.data);
}

export async function getManagerRules(): Promise<any[]> {
  return optionsApi
    .get("/v1/manager-assignment/rules")
    .then((res) => res?.data?.data || []);
}

export async function deleteManagerRule(id: string): Promise<any> {
  return optionsApi
    .delete(`/v1/manager-assignment/rule/${id}`)
    .then((res) => res?.data);
}

export async function reapplyManagerRules(): Promise<any> {
  return optionsApi
    .post("/v1/manager-assignment/rules/reapply", {})
    .then((res) => res?.data);
}

export async function addManagersToEmployees(data: {
  managerIds: string[];
  employeeIds: string[];
}): Promise<any> {
  return optionsApi
    .post("/v1/manager-assignment/employees/managers/add", data)
    .then((res) => res?.data);
}

export async function removeEmployeeManager(data: {
  employeeId: string;
  managerId: string;
}): Promise<any> {
  return optionsApi
    .delete(
      `/v1/manager-assignment/employees/${data.employeeId}/managers/${data.managerId}`
    )
    .then((res) => res?.data);
}

export async function syncEmployeeManagers(data: {
  updates: { employeeId: string; managerIds: string[] }[];
}): Promise<any> {
  return optionsApi
    .post("/v1/manager-assignment/employees/managers/sync", data)
    .then((res) => res?.data);
}

export async function getEmployeeManagers(employeeId: string): Promise<any[]> {
  return optionsApi
    .get(`/v1/manager-assignment/employees/${employeeId}/managers`)
    .then((res) => res?.data?.data || []);
}
